<template>
    <div class="content">
        <better-scroll class="nav" :scrollX="true">
            <div class="wrapper">
                <span class="item" v-for="(item,index) in navList" :key="index" :class="{'item_active':isShow === index}" @click="changeData(item,index)">
                  {{item}}
                </span>
            </div>
        </better-scroll>
    </div>
</template>
<script>
    import betterScroll from '../../components/base/betterScroll'
    export default {
        name: 'tabs',
        components: {
            'better-scroll': betterScroll
        },
        props: {
            navList: {
                type: Array,
                default: null
            }
            // isShow: {
            //     type: Number,
            //     default: null
            // }
        },
        data () {
            return {
                isShow: 0
            }
        },
        created () {

        },
        methods: {
            changeData (item, index) {
                this.isShow = index;
                this.$emit('changeAllData', { item, index })
            }
        }
    }
</script>

<style lang="less" scoped>
    .content{
        width:100%;
        padding:10px 10px 0 10px;
        box-sizing: border-box;
        overflow: hidden;
        position: relative;
        .nav{
            width:100%;
            height:40px;
            .wrapper{
                white-space: nowrap;
                position: absolute;
                padding-right: 14px;
                .item{
                    display: inline-block;
                    padding: 10px 0 10px 0;
                    margin-right: 20px;
                    // border-bottom: 2px solid @base-color;
                    font-size: 14px;
                }
                .item_active{
                    border-bottom: 2px solid @base-color;
                    color:@base-color;
                }
            }

        }
    }
</style>
